/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FeatureInputs */

const en_feature = /** @type {(inputs: FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

const es_feature = /** @type {(inputs: FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacar`)
};

/**
* | output |
* | --- |
* | "Feature" |
*
* @param {FeatureInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const feature = /** @type {((inputs?: FeatureInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FeatureInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_feature(inputs)
	return es_feature(inputs)
});